/* =========================================================
   PRÆSIDENT GULVE - MASTER JAVASCRIPT
   Formål:
   Samlet JavaScript-fil til Shopify.
   Reelle dubletter er fjernet.
   Funktionalitet er bevaret.
   ========================================================= */

(function () {
  /* =========================================================
     1. RELATED PRODUCTS SLIDER
     Bruges til alle .custom-related-products karuseller.
     Gør pilene aktive og scroller produktkort vandret.
     ========================================================= */
  function initRelatedSlider(section) {
    if (!section || section.dataset.ready === "true") return;
    section.dataset.ready = "true";

    var track = section.querySelector(".custom-related-products__track");
    var prevBtn = section.querySelector(".custom-related-products__arrow--prev");
    var nextBtn = section.querySelector(".custom-related-products__arrow--next");

    if (!track || !prevBtn || !nextBtn) return;

    function getStep() {
      var firstCard = track.querySelector(".custom-related-products__card");
      if (!firstCard) return 320;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 5;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 5;
    }

    prevBtn.addEventListener("click", function () {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    nextBtn.addEventListener("click", function () {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);

    updateButtons();
  }

  function initAllRelatedSliders(root) {
    (root || document).querySelectorAll(".custom-related-products").forEach(initRelatedSlider);
  }


  /* =========================================================
     2. "LÆS MERE" PRODUKTBESKRIVELSE
     Bruges på produktkort/produktsektion.
     Scroller ned til Shopify produktbeskrivelsen.
     ========================================================= */
  window.scrollToProductDescription = function () {
    const target = document.querySelector(".collapsible-content__heading");

    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  /* =========================================================
     3. GPO QUANTITY MOVE
     Flytter quantity-feltet efter popup-triggeren.
     Bruges sammen med produkt-configuratorens knapper.
     ========================================================= */
  function moveGpoQuantity() {
    setTimeout(function () {
      var container = document.querySelector('[data-element-id="buttons-1"]');
      if (!container) return;

      var qty = container.querySelector(".gpo-quantity");
      var btn = container.querySelector(".gpo-popup-trigger");

      if (qty && btn) {
        btn.after(qty);
      }
    }, 1000);
  }


  /* =========================================================
     4. BUY NOW FORM
     Bruges til custom "Buy Now" form.
     Tilføjer produktet til kurv via AJAX og sender direkte til checkout.
     ========================================================= */
  function initBuyNowForm() {
    var form = document.getElementById("buy-now-form");
    if (!form || form.dataset.ready === "true") return;

    form.dataset.ready = "true";

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const button = form.querySelector("button");

      button.disabled = true;
      button.innerText = "Processing...";

      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form)
      })
        .then(response => {
          if (!response.ok) {
            throw new Error("Add to cart failed");
          }
          return response.json();
        })
        .then(() => {
          window.location.href = "/checkout";
        })
        .catch(error => {
          console.error(error);
          button.disabled = false;
          button.innerText = "Buy Now";
          alert("Something went wrong. Please try again.");
        });
    });
  }


  /* =========================================================
     5. GPO POPUP / DRAWER SYSTEM
     Omdanner GPO produkt-configuratorens standardvalg til en flot popup/drawer.
     Bruges til:
     - Swatches
     - Dropdowns
     - Checkbox/radio valg
     - Parketlim quantity
     - Hjælp til montering
     ========================================================= */
  function initGpoPopupSystem() {
    if (window.pgGpoPopupSystemReady) return;
    window.pgGpoPopupSystemReady = true;

    const popupState = {
      currentField: null,
      tempValues: [],
      type: null,
      movedField: null,
      movedFieldPlaceholder: null,
      movedFieldOriginalParent: null,
      quantityProxyCleanup: null
    };

    let overlay, drawer, titleEl, subtitleEl, bodyEl, saveBtn, closeBtn, footerEl;

    function createSharedPopup() {
      if (document.querySelector(".gpo-popup-overlay")) {
        overlay = document.querySelector(".gpo-popup-overlay");
        drawer = document.querySelector(".gpo-popup-drawer");
        titleEl = drawer.querySelector(".gpo-popup-title");
        subtitleEl = drawer.querySelector(".gpo-popup-subtitle");
        bodyEl = drawer.querySelector(".gpo-popup-body");
        saveBtn = drawer.querySelector(".gpo-popup-save");
        closeBtn = drawer.querySelector(".gpo-popup-close");
        footerEl = drawer.querySelector(".gpo-popup-footer");
        return;
      }

      overlay = document.createElement("div");
      overlay.className = "gpo-popup-overlay";

      drawer = document.createElement("div");
      drawer.className = "gpo-popup-drawer";
      drawer.innerHTML = `
        <div class="gpo-popup-header">
          <div class="gpo-popup-header-left">
            <h3 class="gpo-popup-title"></h3>
            <div class="gpo-popup-subtitle">Vælg den løsning der passer bedst til dit gulv.</div>
          </div>
          <button type="button" class="gpo-popup-close" aria-label="Luk">&times;</button>
        </div>
        <div class="gpo-popup-body"></div>
        <div class="gpo-popup-footer">
          <button type="button" class="gpo-popup-save">Gem valg</button>
        </div>
      `;

      document.body.appendChild(overlay);
      document.body.appendChild(drawer);

      titleEl = drawer.querySelector(".gpo-popup-title");
      subtitleEl = drawer.querySelector(".gpo-popup-subtitle");
      bodyEl = drawer.querySelector(".gpo-popup-body");
      saveBtn = drawer.querySelector(".gpo-popup-save");
      closeBtn = drawer.querySelector(".gpo-popup-close");
      footerEl = drawer.querySelector(".gpo-popup-footer");

      overlay.addEventListener("click", closePopup);
      closeBtn.addEventListener("click", closePopup);
      saveBtn.addEventListener("click", applyPopupSelection);

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closePopup();
      });
    }

    function lockScroll() {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }

    function unlockScroll() {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    function normalizeText(text) {
      return String(text || "")
        .toLowerCase()
        .replace(/æ/g, "ae")
        .replace(/ø/g, "oe")
        .replace(/å/g, "aa")
        .replace(/\s+/g, " ")
        .trim();
    }

    function escapeHtml(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function getFieldLabel(field) {
      const label = field.querySelector(".label-content");
      return label ? label.textContent.trim() : "Vælg mulighed";
    }

    function isParketlimField(field) {
      return normalizeText(getFieldLabel(field)).includes("parketlim");
    }

    function isMontageHelpField(field) {
      const label = normalizeText(getFieldLabel(field));
      return label.includes("hjaelp til monteringen") || label.includes("hjaelp til montering");
    }

    function isDarkButtonField(field) {
      const label = normalizeText(getFieldLabel(field));
      return label.includes("behandling") || label.includes("kant") || label.includes("andet");
    }

    function shouldConvertField(field) {
      if (!field || field.dataset.popupReady === "true") return false;
      if (field.closest(".gpo-popup-drawer")) return false;
      if (!field.querySelector(".label-content")) return false;

      const hasPopupOptions =
        field.querySelector(".gpo-swatches input") ||
        field.querySelector(".gpo-dropdown input") ||
        field.querySelector(".gpo-choicelist input");

      return !!hasPopupOptions;
    }

    function getFieldType(field) {
      if (field.querySelector(".gpo-dropdown input")) return "dropdown";
      if (field.querySelector('.gpo-choicelist input[type="checkbox"]')) return "checkbox";
      if (field.querySelector('.gpo-choicelist input[type="radio"]')) return "radio";
      if (field.querySelector('.gpo-swatches input[type="checkbox"]')) return "checkbox";
      if (field.querySelector('.gpo-swatches input[type="radio"]')) {
        return field.querySelector(".swatch-image") ? "image" : "radio";
      }
      return "unknown";
    }

    function getCurrentSelectedValues(field) {
      return Array.from(field.querySelectorAll("input:checked")).map(function (input) {
        return input.id;
      });
    }

    function getOptionTitle(input) {
      const item = input.closest(".gpo-ov-item") || input.parentElement;
      const tooltipWord = item ? item.querySelector(".gpo-tooltip__title .break-word") : null;
      const dropdownValue = item ? item.querySelector(".dropdown-item__value") : null;
      const choiceValue = item ? item.querySelector(".choicelist-item__value") : null;

      let value = "";
      if (tooltipWord) value = tooltipWord.textContent.trim();
      else if (dropdownValue) value = dropdownValue.textContent.replace(/\s+/g, " ").trim();
      else if (choiceValue) value = choiceValue.textContent.trim();
      else value = (input.getAttribute("original-value") || input.value || "").trim();

      value = value.replace(/\(\+\s*[\d.,\s]+(?:kr|dkk)\)/ig, "").trim();
      return value;
    }

    function normalizeAddonText(text) {
      const raw = String(text || "").replace(/\s+/g, " ").trim();
      if (!raw) return "";

      const clean = normalizeText(raw);
      if (
        clean === "0" ||
        clean === "0 kr" ||
        clean === "+0 kr" ||
        clean === "0,00 kr" ||
        clean === "+0,00 kr" ||
        clean.includes("gratis")
      ) {
        return "Gratis";
      }

      return raw;
    }

    function getOptionAddon(input) {
      const item = input.closest(".gpo-ov-item") || input.parentElement;
      const addon = item ? item.querySelector(".addOn") : null;
      return addon ? normalizeAddonText(addon.textContent) : "";
    }

    function getOptionImage(input) {
      const item = input.closest(".gpo-ov-item") || input.parentElement;
      const img = item ? item.querySelector(".swatch-image") : null;
      return img ? img.src : "";
    }
        function getOptionQuantityInput(input) {
      const item = input.closest(".gpo-ov-item");
      if (!item) return null;

      return item.querySelector('.gpo-quantity input[type="number"], input[type="number"]');
    }

    function fieldHasPerOptionQuantity(field) {
      return Array.from(field.querySelectorAll(".gpo-ov-item")).some(function (item) {
        return item.querySelector('.gpo-quantity input[type="number"], input[type="number"]');
      });
    }

    function triggerQuantityEvents(input) {
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("blur", { bubbles: true }));
    }

    function createPopupQuantityControl(originalInput) {
      const wrapper = document.createElement("div");
      wrapper.className = "gpo-popup-option-qty";

      const minus = document.createElement("button");
      minus.type = "button";
      minus.className = "gpo-popup-option-qty-btn";
      minus.textContent = "−";

      const input = document.createElement("input");
      input.type = "number";
      input.className = "gpo-popup-option-qty-input";
      input.value = originalInput.value || "1";
      input.min = originalInput.min || "1";
      input.step = originalInput.step || "1";

      if (originalInput.max) {
        input.max = originalInput.max;
      }

      const plus = document.createElement("button");
      plus.type = "button";
      plus.className = "gpo-popup-option-qty-btn";
      plus.textContent = "+";

      function syncToOriginal() {
        originalInput.value = input.value;
        triggerQuantityEvents(originalInput);
      }

      function changeValue(direction) {
        const step = parseFloat(input.step || "1");
        const min = parseFloat(input.min || "1");
        const max = input.max ? parseFloat(input.max) : null;
        let current = parseFloat(input.value || min);

        current = current + direction * step;

        if (current < min) current = min;
        if (max !== null && current > max) current = max;

        input.value = current;
        syncToOriginal();
      }

      minus.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        changeValue(-1);
      });

      plus.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        changeValue(1);
      });

      input.addEventListener("click", function (event) {
        event.stopPropagation();
      });

      input.addEventListener("input", syncToOriginal);
      input.addEventListener("change", syncToOriginal);

      wrapper.addEventListener("click", function (event) {
        event.stopPropagation();
      });

      wrapper.appendChild(minus);
      wrapper.appendChild(input);
      wrapper.appendChild(plus);

      return wrapper;
    }

    function getFieldOptions(field) {
      const type = getFieldType(field);
      let inputs = [];

      if (type === "dropdown") {
        inputs = Array.from(field.querySelectorAll(".gpo-dropdown input"));
      } else if (type === "checkbox") {
        inputs = Array.from(field.querySelectorAll(".gpo-choicelist input, .gpo-swatches input"));
      } else {
        inputs = Array.from(field.querySelectorAll(".gpo-swatches input, .gpo-choicelist input"));
      }

      const seen = new Set();

      return inputs
        .filter(function (input) {
          if (!input || !input.id || seen.has(input.id)) return false;
          seen.add(input.id);
          return true;
        })
        .map(function (input) {
          return {
            id: input.id,
            title: getOptionTitle(input),
            addon: getOptionAddon(input),
            image: getOptionImage(input),
            input: input
          };
        });
    }

    function getSelectedOption(field) {
      const options = getFieldOptions(field);
      const selectedId = popupState.tempValues[0];
      return options.find(function (option) {
        return option.id === selectedId;
      }) || null;
    }

    function shouldShowQuantity(field) {
      const selectedOption = getSelectedOption(field);
      if (!selectedOption) return false;

      const quantityField = findQuantityField(field);
      if (!quantityField) return false;

      return true;
    }

    function findQuantityField(field) {
      if (!field) return null;

      const directInput = field.querySelector(".gpo-dropdown input[data-field-name], .gpo-swatches input[data-field-name], .gpo-choicelist input[data-field-name]");
      const parentFieldName = directInput ? directInput.getAttribute("data-field-name") : "";

      if (parentFieldName) {
        const quantityInput = document.querySelector(
          '.gpo-quantity input[data-parent-field-name="' + CSS.escape(parentFieldName) + '"]'
        );
        if (quantityInput) return quantityInput.closest(".gpo-quantity");
      }

      let next = field.nextElementSibling;
      while (next) {
        if (next.classList && next.classList.contains("gpo-element")) break;
        const qty = next.querySelector ? next.querySelector(".gpo-quantity") : null;
        if (qty) return qty;
        next = next.nextElementSibling;
      }

      return null;
    }

    function restoreMovedField() {
      if (typeof popupState.quantityProxyCleanup === "function") {
        popupState.quantityProxyCleanup();
      }
      popupState.quantityProxyCleanup = null;
      popupState.movedField = null;
      popupState.movedFieldPlaceholder = null;
      popupState.movedFieldOriginalParent = null;
    }

    function moveQuantityFieldIntoPopup(field) {
      restoreMovedField();

      if (!shouldShowQuantity(field)) return;

      const quantityField = findQuantityField(field);
      if (!quantityField) return;

      const originalInput = quantityField.querySelector("input");
      if (!originalInput) return;

      const existingLabel = quantityField.querySelector(".gpo-quantity__label");
      const labelText = existingLabel ? existingLabel.textContent.trim() : "Antal";

      const wrapper = document.createElement("div");
      wrapper.className = "gpo-popup-extra-field";

      wrapper.innerHTML = `
        <div class="gpo-popup-extra-title">${escapeHtml(labelText)}</div>
        <div class="gpo-quantity">
          <input
            type="number"
            min="${escapeHtml(originalInput.min || "1")}"
            max="${escapeHtml(originalInput.max || "")}"
            step="${escapeHtml(originalInput.step || "1")}"
            value="${escapeHtml(originalInput.value || "1")}"
            class="gpo-quantity__input gpo-popup-quantity-proxy"
          >
        </div>
      `;

      bodyEl.appendChild(wrapper);

      const proxyInput = wrapper.querySelector(".gpo-popup-quantity-proxy");

      const syncToOriginal = function () {
        originalInput.value = proxyInput.value;
        originalInput.dispatchEvent(new Event("input", { bubbles: true }));
        originalInput.dispatchEvent(new Event("change", { bubbles: true }));
        originalInput.dispatchEvent(new Event("blur", { bubbles: true }));
      };

      const syncFromOriginal = function () {
        proxyInput.value = originalInput.value || proxyInput.value;
      };

      proxyInput.addEventListener("input", syncToOriginal);
      proxyInput.addEventListener("change", syncToOriginal);
      originalInput.addEventListener("input", syncFromOriginal);
      originalInput.addEventListener("change", syncFromOriginal);

      popupState.quantityProxyCleanup = function () {
        proxyInput.removeEventListener("input", syncToOriginal);
        proxyInput.removeEventListener("change", syncToOriginal);
        originalInput.removeEventListener("input", syncFromOriginal);
        originalInput.removeEventListener("change", syncFromOriginal);
      };
    }

    function renderPopupHelp(field) {
      if (!isMontageHelpField(field)) return;

      const help = document.createElement("div");
      help.className = "gpo-popup-help";
      help.innerHTML = `
        <em>* Hvis I trykker ja:</em> I vil blive ringet op af vores dygtige montagefirma, som gratis kan komme ud og give jer et tilbud på lægningen af jeres gulv i forbindelse med køb af gulvet hos Præsidentgulve.
      `;
      bodyEl.appendChild(help);
    }

    function renderPopupOptions(field) {
      bodyEl.innerHTML = "";
      restoreMovedField();

      renderPopupHelp(field);

      const type = getFieldType(field);
      const options = getFieldOptions(field);

      const grid = document.createElement("div");
      grid.className = "gpo-popup-grid";

      const hasImages = options.some(function (option) {
        return !!option.image;
      });

      if (!hasImages) {
        grid.classList.add("text-list");
      }

      const useDarkButtons = isDarkButtonField(field);

      options.forEach(function (option) {
        const active = popupState.tempValues.includes(option.id);
        const hasImage = !!option.image;

        const card = document.createElement("div");
        card.className = "gpo-popup-option" + (active ? " active" : "") + (!hasImage ? " text-only" : "");
        card.setAttribute("data-option-id", option.id);

        const addonHtml = option.addon ? `<div class="gpo-popup-option-addon">${escapeHtml(option.addon)}</div>` : "";
        const buttonStyle = useDarkButtons ? ' style="background:#111;color:#fff;border-color:#111;"' : "";

        if (hasImage) {
          card.innerHTML = `
            <div class="gpo-popup-option-image">
              <img src="${option.image}" alt="${escapeHtml(option.title)}">
            </div>
            <div class="gpo-popup-option-content">
              <div class="gpo-popup-option-title">${escapeHtml(option.title)}</div>
              ${addonHtml}
              <div class="gpo-popup-option-select"${buttonStyle}>Vælg</div>
            </div>
          `;
        } else {
          card.innerHTML = `
            <div class="gpo-popup-option-content">
              <div class="gpo-popup-option-title">${escapeHtml(option.title)}</div>
              ${addonHtml}
              <div class="gpo-popup-option-select"${buttonStyle}>Vælg</div>
            </div>
          `;
        }
        const optionQuantityInput = getOptionQuantityInput(option.input);

        if (optionQuantityInput) {
          const content = card.querySelector(".gpo-popup-option-content");

          if (content) {
            content.appendChild(createPopupQuantityControl(optionQuantityInput));
          }
        }

        card.addEventListener("click", function (event) {
        if (event.target.closest(".gpo-popup-option-qty")) {
          return;
        }

        if (type === "checkbox") {
          if (popupState.tempValues.includes(option.id)) {
            popupState.tempValues = popupState.tempValues.filter(function (id) {
              return id !== option.id;
            });
          } else {
            popupState.tempValues.push(option.id);
          }

          renderPopupOptions(field);
          return;
        }

  popupState.tempValues = [option.id];

  renderPopupOptions(field);
});

        grid.appendChild(card);
      });

      bodyEl.appendChild(grid);

      if (!fieldHasPerOptionQuantity(field)) {
      moveQuantityFieldIntoPopup(field);
}
    }

    function clickOriginalOption(field, inputId) {
      const input = field.querySelector("#" + CSS.escape(inputId));
      if (!input) return false;

      const label = field.querySelector('label[for="' + CSS.escape(inputId) + '"]');
      if (label) {
        label.click();
        return true;
      }

      input.click();
      return true;
    }

    function getSelectedText(field) {
      const checkedInputs = Array.from(field.querySelectorAll("input:checked"));
      if (!checkedInputs.length) return "Tryk for at vælge";

      return checkedInputs.map(function (input) {
        const title = getOptionTitle(input);
        const addon = getOptionAddon(input);
        return addon ? title + " " + addon : title;
      }).join(", ");
    }

    function updateTriggerValue(field) {
      const triggerValue = field.querySelector(".gpo-popup-trigger-value");
      const selectedValueEl = field.querySelector(".gpo-selected-values");
      const value = getSelectedText(field);

      if (triggerValue) triggerValue.textContent = value;
      if (selectedValueEl) selectedValueEl.textContent = value;
    }

    function applyPopupSelection() {
      const field = popupState.currentField;
      if (!field) return;

      const type = getFieldType(field);
      const inputs = Array.from(field.querySelectorAll('input[type="radio"], input[type="checkbox"]'));

      if (type === "checkbox") {
        inputs.forEach(function (input) {
          const shouldBeChecked = popupState.tempValues.includes(input.id);
          if (input.checked !== shouldBeChecked) {
            clickOriginalOption(field, input.id);
          }
        });
      } else {
        const selectedId = popupState.tempValues[0];
        if (selectedId) {
          clickOriginalOption(field, selectedId);
        }
      }

      setTimeout(function () {
        updateTriggerValue(field);
        closePopup();
      }, 80);
    }

  function openPopup(field) {
    popupState.currentField = field;
    popupState.type = getFieldType(field);
    popupState.tempValues = getCurrentSelectedValues(field);

    titleEl.textContent = getFieldLabel(field) || "Vælg mulighed";

    subtitleEl.textContent = "Vælg den løsning der passer bedst til dit gulv, og tryk derefter på Bekræft valg.";
    footerEl.classList.remove("hidden");

    if (saveBtn) {
      saveBtn.textContent = "Bekræft valg";
    }

    renderPopupOptions(field);

    overlay.classList.add("active");
    drawer.classList.add("active");
    lockScroll();
  }

    function closePopup() {
      if (!overlay || !drawer) return;
      overlay.classList.remove("active");
      drawer.classList.remove("active");
      restoreMovedField();
      unlockScroll();
    }

    function initPopupField(field) {
      if (!shouldConvertField(field)) return;

      field.dataset.popupReady = "true";

      const labelEl = field.querySelector(".gpo-label");
      const selectedValueEl = field.querySelector(".gpo-selected-values");
      const labelText = getFieldLabel(field);

      const existingHelp = field.querySelector(".gpo-inline-help");
      if (existingHelp) {
        existingHelp.style.display = "none";
      }

      const trigger = document.createElement("button");
      trigger.type = "button";
      trigger.className = "gpo-popup-trigger";
      trigger.innerHTML = `
        <span class="gpo-popup-trigger-left">
          <span class="gpo-popup-trigger-label">${escapeHtml(labelText)}</span>
          <span class="gpo-popup-trigger-value">${escapeHtml(getSelectedText(field))}</span>
        </span>
        <span class="gpo-popup-trigger-icon">›</span>
      `;

      const originalBlocks = field.querySelectorAll(".gpo-ov-wrapper, .gpo-dropdown, .gpo-select");
      originalBlocks.forEach(function (el) {
        el.classList.add("gpo-popup-hidden-original");
      });

      if (labelEl) labelEl.style.display = "none";
      if (selectedValueEl) selectedValueEl.style.display = "none";

      field.appendChild(trigger);

      trigger.addEventListener("click", function () {
        openPopup(field);
      });

      field.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
        input.addEventListener("change", function () {
          updateTriggerValue(field);
        });
      });

      updateTriggerValue(field);
    }

    function initAllPopupFields() {
      createSharedPopup();
      document.querySelectorAll(".gpo-element").forEach(initPopupField);
    }

    initAllPopupFields();

    const observer = new MutationObserver(function () {
      initAllPopupFields();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


  /* =========================================================
     6. GLOBAL INITIALIZATION
     Kører alt når siden loader.
     Shopify section reload understøttes også.
     ========================================================= */
  document.addEventListener("DOMContentLoaded", function () {
    initAllRelatedSliders(document);
    moveGpoQuantity();
    initBuyNowForm();
    initGpoPopupSystem();
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllRelatedSliders(event.target);
    moveGpoQuantity();
    initBuyNowForm();
  });
})();


/*
  LUX SLIDER JAVASCRIPT
  Funktionalitet til forsideslider/banner:
  næste/forrige pile, aktiv slide, progress bar og automatisk skift hvert 5. sekund.
*/

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".lux-slider");

  if (!slider) return;

  const slides = slider.querySelectorAll(".lux-slide");
  const nextBtn = slider.querySelector(".lux-next");
  const prevBtn = slider.querySelector(".lux-prev");

  if (!slides.length || !nextBtn || !prevBtn) return;

  let current = 0;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });

    slider.classList.toggle("slide-2", index === 1);
  }

  nextBtn.addEventListener("click", function () {
    current = (current + 1) % slides.length;
    showSlide(current);
  });

  prevBtn.addEventListener("click", function () {
    current = (current - 1 + slides.length) % slides.length;
    showSlide(current);
  });

  setInterval(function () {
    current = (current + 1) % slides.length;
    showSlide(current);
  }, 5000);

  showSlide(current);
});
/* =========================================================
   GPO CONFIGURATOR — FINAL 4-COLUMN SWATCH LAYOUT
   ========================================================= */
(function () {
  var css = `
    .gpo-popup-grid {
      display: grid !important;
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
      gap: 12px !important;
    }

    .gpo-popup-grid.text-list {
      grid-template-columns: 1fr !important;
    }

    .gpo-popup-option {
      position: relative !important;
      display: flex !important;
      flex-direction: column !important;
      border: 0.5px solid #e6e6e6 !important;
      border-radius: 16px !important;
      background: #fff !important;
      overflow: hidden !important;
      box-shadow: none !important;
      cursor: pointer !important;
      transition: transform .18s ease, border-color .18s ease, box-shadow .18s ease !important;
    }

    .gpo-popup-option:hover {
      transform: translateY(-2px) !important;
      border-color: #cdcdcd !important;
      box-shadow: 0 12px 26px rgba(0,0,0,0.08) !important;
    }

    .gpo-popup-option-image {
      width: 100% !important;
      aspect-ratio: 1 / 1 !important;
      flex-shrink: 0 !important;
      overflow: hidden !important;
      background: #f4f3f0 !important;
    }

    .gpo-popup-option-image img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      display: block !important;
    }

    .gpo-popup-option-content {
      padding: 10px 12px 12px !important;
      display: flex !important;
      flex-direction: column !important;
      flex: 1 1 auto !important;
    }

    .gpo-popup-option-title {
      font-size: 14px !important;
      font-weight: 700 !important;
      color: #111 !important;
      line-height: 1.3 !important;
    }

    .gpo-popup-option-addon {
      display: inline-block !important;
      align-self: flex-start !important;
      margin-top: 6px !important;
      background: #e4ff7a !important;
      color: #3a4a00 !important;
      font-weight: 700 !important;
      font-size: 12px !important;
      line-height: 1.2 !important;
      padding: 3px 8px !important;
      border-radius: 6px !important;
    }

    .gpo-popup-option-select {
      display: none !important;
    }

    .gpo-popup-option.active {
      border-color: #111 !important;
      box-shadow: 0 10px 26px rgba(0,0,0,0.10) !important;
    }

    .gpo-popup-option.active::before {
      content: "" !important;
      position: absolute !important;
      inset: 0 !important;
      border: 2px solid #111 !important;
      border-radius: inherit !important;
      pointer-events: none !important;
      z-index: 3 !important;
    }

    .gpo-popup-option.active::after {
      content: "✓" !important;
      position: absolute !important;
      top: 10px !important;
      right: 10px !important;
      width: 28px !important;
      height: 28px !important;
      border-radius: 999px !important;
      background: #e4ff7a !important;
      color: #2c3a00 !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      z-index: 4 !important;
    }

    .gpo-popup-option.text-only {
      padding: 16px 18px !important;
      border-radius: 14px !important;
    }

    .gpo-popup-option.text-only .gpo-popup-option-content {
      padding: 0 !important;
    }

    .gpo-popup-save {
      border-radius: 999px !important;
    }

    @media (max-width: 767px) {
      .gpo-popup-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      }
    }
  `;

  function injectStyle() {
    var old1 = document.getElementById("gpo-modern-fixes");
    var old2 = document.getElementById("gpo-2026-style");
    var old3 = document.getElementById("gpo-four-column-fix");

    if (old1) old1.remove();
    if (old2) old2.remove();
    if (old3) old3.remove();

    if (document.getElementById("gpo-final-swatch-layout")) return;

    var style = document.createElement("style");
    style.id = "gpo-final-swatch-layout";
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  injectStyle();
  document.addEventListener("DOMContentLoaded", injectStyle);
})();

